export default __webpack_public_path__ + "c640e4a80fa5b438e1c4f8a55ef43235.png";